module.exports = __webpack_public_path__ + "static/media/banner3.cdb5d8b3.png";